import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { SituationsSection } from '../components/SituationsSection';
import { PainSection } from '../components/PainSection';
import { MechanismSection } from '../components/MechanismSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { PackSection } from '../components/PackSection';
import { PricingSection } from '../components/PricingSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { CTASection } from '../components/CTASection';
import { FAQSection } from '../components/FAQSection';
import { ImaginateSection } from '../components/ImaginateSection';
export function LandingPage() {
  return <div className="min-h-screen font-sans text-gray-900 bg-[#FEE9D0]" data-id="element-311">
      <nav className="absolute top-0 left-0 w-full pt-4 pb-3 px-6 z-50" data-id="element-312">
        <div className="container mx-auto flex justify-between items-center" data-id="element-313">
          <div className="font-heading font-extrabold text-2xl text-orange-600 flex items-center gap-2" data-id="element-314">
            <img src="https://cdn.magicpatterns.com/uploads/cKDTNUcYJHYBaLM9bkArox/6.png" alt="Cocina Simple Ya logo" className="h-10 w-10 object-contain" style={{
            mixBlendMode: 'multiply'
          }} data-id="element-315" />
            Cocina Simple YA!
          </div>
        </div>
      </nav>

      <main data-id="element-316">
        <HeroSection data-id="element-317" />
        <SituationsSection data-id="element-318" />
        <PainSection data-id="element-319" />
        <MechanismSection data-id="element-320" />
        <FeaturesSection data-id="element-321" />
        <PricingSection data-id="element-322" />
        <GuaranteeSection data-id="element-323" />
        <PackSection data-id="element-324" />
        <BenefitsSection data-id="element-325" />
        <TestimonialsSection data-id="element-326" />
        <FAQSection data-id="element-327" />
        <ImaginateSection data-id="element-328" />
        <CTASection data-id="element-329" />
      </main>

      <footer className="bg-gray-900 text-gray-400 py-12 text-center" data-id="element-330">
        <div className="container mx-auto px-4" data-id="element-331">
          <p className="mb-4" data-id="element-332">
            &copy; 2024 Cocina Simple Ya!. Todos los derechos reservados.
          </p>
          <div className="flex justify-center gap-6 text-sm" data-id="element-333">
            <a href="#" className="hover:text-white transition-colors" data-id="element-334">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-335">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-336">
              Contacto
            </a>
          </div>
        </div>
      </footer>
    </div>;
}